<template>
    <q-layout>

        <!-- Content -->
        <q-page-container>
            <child/>
        </q-page-container>

    </q-layout>
</template>

<script>
    import {
        QLayout,
        QPageContainer
    } from 'quasar-framework'

    export default {
        name: 'BasicLayout',

        components: {
            QLayout,
            QPageContainer
        }
    }
</script>

<style>
.text-white {
  color: #FFFDF8 !important;
}

.bg-white,
.q-popover,
.q-tab,
.q-layout-drawer{
  background: #FFFFFF !important;
}

.bg-info {
  background: #287baf !important;
}

.bg-positive {
  background: #00d1d2 !important;
}

body,
.text-dark,
.q-table
{
  color: #34303d !important;
}

/* .q-if-label
{
  color: #c2c0c2 !important;
} */

.q-input-target,
.q-table th,
.q-table-bottom
{
  color: #524f5a !important;
}

.q-chip {
  color: #34303d;
  background: #E1E0E2;
}

.text-red {
  color: #db3624 !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/basic.vue